import {rgba} from 'polished';

const COLORS = {
	red50: '#FFEAED',
	red100: '#FFCBD0',
	red200: '#F69695',
	red300: '#EE6C6C',
	red400: '#F84746',
	red500: '#FD3027',
	red600: '#EF2327',
	red700: '#DD1322',
	red800: '#D0021B',
	pink50: '#FCE4F4',
	pink100: '#F9BAE4',
	pink200: '#F98BD2',
	pink300: '#FB54BD',
	pink400: '#FF00AA',
	pink500: '#FF0094',
	pink600: '#F2008F',
	pink700: '#DA0089',
	pink800: '#C30084',
	purple50: '#F3E5F5',
	purple100: '#E1BEE7',
	purple200: '#CE93D8',
	purple300: '#BA68C8',
	purple400: '#AB47BC',
	purple500: '#9B27B0',
	purple600: '#8D24AA',
	purple700: '#7A1FA2',
	purple800: '#691B9A',
	brand50: '#F0E6FD',
	brand100: '#D7C1F9',
	brand200: '#BC97F5',
	brand300: '#A069F2',
	brand400: '#8843EF',
	brand500: '#6E0FEB',
	brand600: '#6207E5',
	brand700: '#5000DD',
	brand800: '#3B00D7',
	blue50: '#E2F1FF',
	blue100: '#B9DCFF',
	blue200: '#8AC7FF',
	blue300: '#56B0FF',
	blue400: '#279FFF',
	blue500: '#008EFF',
	blue600: '#0081FF',
	blue700: '#146DEA',
	blue800: '#1C5BD8',
	pine50: '#E0F2F1',
	pine100: '#B2DFDB',
	pine200: '#80CBC3',
	pine300: '#4DB6AB',
	pine400: '#26A69A',
	pine500: '#009687',
	pine600: '#00897A',
	pine700: '#00796A',
	pine800: '#00695B',
	green50: '#E1FAED',
	green100: '#B5F3D3',
	green200: '#7DEAB7',
	green300: '#05E298',
	green400: '#00DA80',
	green500: '#00D06B',
	green600: '#00BF5F',
	green700: '#00AC51',
	green800: '#009A45',
	yellow50: '#FFFBE5',
	yellow100: '#FFF4BF',
	yellow200: '#FDEF95',
	yellow300: '#FBE96A',
	yellow400: '#F7E346',
	yellow500: '#F4DE16',
	yellow600: '#E5CC12',
	yellow700: '#D1B608',
	yellow800: '#BD9F01',
	orange50: '#FFF8E1',
	orange100: '#FFECB4',
	orange200: '#FFDF83',
	orange300: '#FFD451',
	orange400: '#FFC92D',
	orange500: '#FFC015',
	orange600: '#FFB210',
	orange700: '#FF9F0F',
	orange800: '#FF8E0F',
	dark100: '#91919B',
	dark200: '#81818B',
	dark300: '#6F6F7A',
	dark400: '#5E5E69',
	dark500: '#4C4C58',
	dark600: '#3B3B47',
	dark700: '#292936',
	dark800: '#181825',
	light100: '#FFFFFF',
	light200: '#F7F7FE',
	light300: '#E6E6ED',
	light400: '#D5D5DD',
	light500: '#C4C4CC',
	light600: '#B2B2BB',
	light700: '#A5A5AE',
	light800: '#9A9AA4',
};

export const theme = {
	typographyDark: {
		primary: COLORS.light100,
		secondary: COLORS.light600,
		disabled: COLORS.dark200,
	},
	typographyLight: {
		primary: COLORS.dark500,
		secondary: COLORS.light700,
		disabled: COLORS.light500,
	},
	background: {
		primary: COLORS.light100,
		secondary: COLORS.light200,
		tertiary: COLORS.light300,
	},
	border: {
		primary: COLORS.light300,
		secondary: COLORS.light500,
	},
	name: 'forecast',
	fontFamily: '"neue-haas-grotesk-text","sans-serif"',
	fontSizes: {
		default: '20px',
		buttonStandard: '10px',
	},
	colors: {
		green: '#05e298',
		darkPurple: '#470c93',
		forecastPurple: COLORS.brand500,
		forecastPurpleMedium: COLORS.brand400,
		forecastPurpleLight: COLORS.brand50,
		hoverPurple: '#6f49c5',
		starYellow: '#F6DA1A',
		starYellowLight: '#fefdf3',
		darkGray: '#4a4a4a',
		textGray: '#535353',
		mediumGray: '#f3f3f3',
		textLightGray: '#545454',
		lightGray: '#9f9f9f',
		mediumLightGray: '#a1a1a1',
		mediumVeryLightGray: '#cecece',
		veryLightGray: '#e6e6e6',
		veryVeryLightGray: '#f5f5f5',
		fixedElementGrey: '#f5f5f8',
		warningRed: '#E4253B',
		white: '#fff',
		negativeValue: '#d0021b',
		opaqueGray: rgba(0, 0, 0, 0.3),
		nonOpaqueGray: '#b1b1b1', //Exactly color match to opaqueGray, but not opaque
	},

	borderWidths: {
		standard: '1px',
	},
};
